<template>
  <div class="dispatch-home">
    <div :class="{'rsvp-panel-container':true, 'shrink':isShrink}">
      <div class="header">
        <div v-show="tabIndex === 0" class="header-filter">
          <div class="search">
            <reservation-search></reservation-search>
          </div>
          <div class="filter-group">
            <div class="filter">
              <reservation-filter addCustom="true"></reservation-filter>
            </div>
            <div :class="{'more-filter-trigger':true, 'active':showFilter}" @click="showCustomFilter">
              <div>
                <i class="fas fa-filter"></i>
                <span v-if="!isShrink">Filter</span>
              </div>
            </div>
          </div>
          <transition name="slide-up">
            <dispatch-more-filter v-show="showFilter" class="more-filter"
              @close="showFilter = false" :shrink="isShrink"></dispatch-more-filter>
          </transition>
        </div>
        <div v-show="tabIndex === 3">
          <runs-table-filter :shrink="isShrink" ref="runsTableFilter"></runs-table-filter>
        </div>
        <div v-show="[1, 2].indexOf(tabIndex) > -1">
          <routing-header></routing-header>
        </div>
      </div>

      <a @click="expand" class="expand-button" v-show="tabIndex === 0">
        <i class="fas fa-chevron-right fa-lg"></i>
      </a>

      <a @click="shrinkTable" class="shrink-button" v-if="!isShrink" v-show="tabIndex === 0">
        <i class="fas fa-chevron-left fa-lg"></i>
      </a>

      <div class="tabs" v-show="!isShrink" :class="tabIndex != 0 ? 'hide-top' : ''">
        <div :class="['tab', {selected: tabIndex === 0 }]" @click="tabIndex = 0">FOR DISPATCH</div>
        <div :class="['tab', {selected: tabIndex === 3 }]" @click="tabIndex = 3">RUNS</div>
        <div :class="['tab', {selected: tabIndex === 1 }]" @click="tabIndex = 1">ROUTED PACKAGES</div>
        <div :class="['tab', {selected: tabIndex === 2 }]" @click="tabIndex = 2">UNPACKAGED RESERVATIONS</div>
        <div class="total">
          Total: {{total()}} |
          <span v-if="!!lastSync">Updated: <b>{{lastSync}}</b></span>
        </div>
      </div>
      <div :class="['rsvp-panel', tabIndex != 0 ? 'hide-top' : '']">
        <div :class="['tab-content', {show: tabIndex === 0 }]">
          <reservations-table :isShort="true" :shrink="isShrink"></reservations-table>
        </div>
        <div :class="['tab-content', {show: tabIndex === 3 }]">
          <runs-tables ref="runsTable"></runs-tables>
        </div>
        <div :class="['tab-content with-control', {show: tabIndex === 1 }]" @scroll="onScrollPackage">
          <routing-packages-table :forDispatch="true" ref="routingPkgTable" :isMobile="isMobile"></routing-packages-table>
          <routing-packages-control :forDispatch="true" class="tab-control"></routing-packages-control>
        </div>
        <div :class="['tab-content', {show: tabIndex === 2 }]" @scroll="onScrollUnpackage">
          <routing-reservations-table ref="routingRsvpTable" :isMobile="isMobile"></routing-reservations-table>
        </div>
      </div>
    </div>

    <a :class="['driver-toggle', {on:!showDriverPanel, hide:showFilter}]" @click="toggleDriverPanel" href="javascript:;"
      v-show="tabIndex !== 2">
      <i :class="['fa-lg fa-fw', {'far fa-times-circle':showDriverPanel,'fas fa-car':!showDriverPanel}]"></i>
    </a>
    <a href="javascript:;" @click="hideMap" :class="{'close-map-button':rsvpInMap.id}">
      <i class="far fa-times-circle"></i>
    </a>
    <div :class="['available-drivers', {hide: !showDriverPanel || tabIndex === 2}]">
      <transition name="grown-in">
        <driver-service-filter v-show="showServiceFilter"></driver-service-filter>
      </transition>
      <available-drivers :tabIndex="tabIndex" ref="availableDrivers"></available-drivers>
    </div>

    <a :class="['availability-toggle', {
      open: availability.show, 
      hide: (tabIndex === 0 && (rsvp === null || rsvp.driver !== null)) || tabIndex === 1 || tabIndex === 2 || !availability.showToggle || showDriverPanel || (tabIndex === 3 && !runs.selected)}]"
      href="javascript:;" @click="availability.show = !availability.show">
      <i class="fas fa-spinner fa-spin fa-lg fa-fw" v-if="rsvpAvailabilityLoading"></i>
      <i class="far fa-calendar-alt fa-lg fa-fw" v-else></i>
    </a>

    <a :class="['coverage-toggle', {hide: showDriverPanel || tabIndex === 1 || tabIndex === 2}]" href="/#/coverage">
      <!-- <i class="far fa-calendar-alt fa-lg"></i> -->
      <i class="fas fa-map-marked-alt fa-lg"></i>
    </a>

    <div :class="{'map':true, 'shrink':isShrink, 'showInMobile':rsvpInMap.id}" v-if="tabIndex === 0">
      <!-- <dispatch-map v-if="$route.name === 'Dispatch'"></dispatch-map> -->
      <dispatch-map2 ref="hereMap"></dispatch-map2>
    </div>

    <dispatch-modal></dispatch-modal>
    <dispatch-notification></dispatch-notification>
    <dispatch-schedule></dispatch-schedule>

    <div class="toggle-mobile" @click="showMapMobile = !showMapMobile" v-if="[0, 3].indexOf(tabIndex) === -1">
      <span v-if="!showMapMobile">Show Map <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Map <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['right-panel', showMapMobile ? 'showMapBox' : '']" v-if="[0, 3].indexOf(tabIndex) === -1">
      <div class="map">
        <!-- <routing-map v-if="$route.name === 'Dispatch' || $route.name === 'Routing'" ref="routingMap"></routing-map> -->
        <routing-map2></routing-map2>
      </div>
      <div class="dropzone-container">
        <routing-drop-zone></routing-drop-zone>
      </div>
    </div>

    <div class="right-panel" v-if="tabIndex === 3">
      <div class="map">
        <runs-map ref="hereMap"></runs-map>
      </div>
      <div class="dropzone-container">
        <runs-dropzone></runs-dropzone>
      </div>
    </div>

    <div :class="['filter-available-drivers', {hide:!availability.show || (tabIndex === 0 && rsvp === null) || (tabIndex === 3 && !runs.selected)}]">
      <div class="d-flex justify-space-between align-stretch">
        <div class="message">Available drivers for this trip</div>
        <div class="close-filter" @click="availability.show = false">
          <i class="fa-lg fa-fw far fa-times-circle"></i>
        </div>
      </div>
      <rsvp-available-drivers></rsvp-available-drivers>
    </div>

    <routing-modal></routing-modal>
    <ready-to-go-modal></ready-to-go-modal>
    <notes-modal></notes-modal>
    <pickup-date-modal></pickup-date-modal>
    <lyft />
  </div>
</template>

<script>
// import moment from 'moment'
import AvailableDrivers from './AvailableDrivers'
// import DispatchMap from './Map'
import DispatchMap2 from './Map2'
import DispatchModal from './DispatchModal'
import DispatchNotification from './DispatchNotification'
import DispatchSchedule from './DispatchSchedule'
import ReservationsTable from './ReservationsTable'
import ReservationFilter from '@/components/Partials/ReservationFilter'
import ReservationSearch from '@/components/Partials/ReservationSearch'
import DispatchMoreFilter from './MoreFilter'
import RoutingHeader from '../Routing/Header'
import RoutingPackagesTable from '../Routing/PackagesTable'
import RoutingPackagesControl from '../Routing/PackagesControl'
import RoutingReservationsTable from '../Routing/ReservationsTable'
import PickupDateModal from '../Routing/PickupDateModal'
// import RoutingMap from '../Routing/Map'
import RoutingMap2 from '../Routing/Map2'
import RoutingDropZone from '../Routing/DropZone'
import RoutingModal from '../Routing/RoutingModal'
import ReadyToGoModal from './ReadyToGoModal'
import NotesModal from './NotesModal'
import DriverServiceFilter from './DriverServiceFilter'
import runsTables from '../Runs/Tables'
import runsTableFilter from '../Runs/TableFilter'
import runsMap from '../Runs/Map'
import runsDropzone from '../Runs/Dropzone'
import RsvpAvailableDrivers from './RsvpAvailableDrivers'
import Lyft from './LyftServices'
import ft from '@/modules/api/featureToggle'

export default {
  name: 'dispatch-home',
  components: {
    AvailableDrivers, DispatchMap2, DispatchModal, DispatchNotification, DispatchSchedule,
    ReservationsTable, ReservationFilter, ReservationSearch, DispatchMoreFilter,
    RoutingHeader, RoutingPackagesControl, RoutingPackagesTable,
    RoutingReservationsTable, PickupDateModal,RoutingMap2, RoutingDropZone, 
    RoutingModal, ReadyToGoModal, NotesModal, DriverServiceFilter,
    runsTables, runsTableFilter, runsMap, runsDropzone, RsvpAvailableDrivers,
    Lyft
  },
  data () {
    return {
      showDriverPanel: false,
      isShrink: false,
      showFilter: false,
      tabIndex: 0,
      runsLoaded: false,
      availability: {
        showToggle: false,
        show: false,
      },
      rsvp: null,
      isMobile: false,
      showMapMobile: false,
      queueError: {
        show: false,
        message: '',
        unfiltered: [],
        unqualified: [],
        reasonsModal: false
      }
    }
  },
  computed: {
    rsvpInMap () { return this.$store.state.dispatch.rsvpInMap },
    selectedFilter () { return this.$store.state.reservation.selectedFilter },
    showServiceFilter () { return this.$store.state.dispatch.serviceFilter.show },
    lastSync () { return this.$store.state.dispatch.lastSync },
    runs () { return this.$store.state.runs },
    rsvpAvailabilityLoading: {
      get () { return this.$store.state.dispatch.availableDrivers.loading },
      set (x) { this.$store.commit('dispatch/setAvailableDriversData', {loading: x})}
    }
  },
  methods: {
    toggleDriverPanel () {
      let self = this
      self.showDriverPanel = !self.showDriverPanel
    },
    expand () {
      if (this.isShrink) {
        this.isShrink = false
        return
      }
      window.location = '/#/dispatch/reservations'
    },
    showCustomFilter () {
      if (this.showFilter) {
        this.showFilter = false
          return
      }
      this.showFilter = true
      this.$store.commit('reservation/setSelectedFilter', 'custom')
    },
    onScrollUnpackage (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingRsvpTable.onScroll()) { this.$refs.routingRsvpTable.onScroll() }
      }
    },
    onScrollPackage (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingPkgTable.onScroll()) { this.$refs.routingPkgTable.onScroll() }
      }
    },
    shrinkTable () {
      this.isShrink = true
      if (this.$refs.hereMap.resizeMap()) {
        this.$refs.hereMap.resizeMap()
      }
    },
    total () {
      switch (this.tabIndex) {
        case 0: return this.$store.state.dispatch.totalItem
        case 1: return this.$store.state.routing.totalItem.pkg
        case 2: return this.$store.state.routing.totalItem.rsvp
        case 3: return this.$store.state.runs.list.length
      }
      return 0
    },
    hideMap () {
      let self = this
      self.$store.commit('dispatch/removeRsvpInMap')
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    checkAvailableDrivers (data) {
      // if (!data.id) return
      // if (data.status !== 'UPCOMING' && data.status !== 'REQUIRES DISPATCH') return

      // let self = this
      // if (self.rsvpAvailabilityLoading) return
      // self.rsvpAvailabilityLoading = true

      // let since = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').format('X')
      // let until = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').add(data.etaInSec, 'seconds').format('X')
      // if (data.lastDropoff) {
      //   until = moment(data.lastDropoff, 'MM/DD/YYYY hh:mmA').format('X')
      // }
      // self.$sdk.get('/shifts/dashboard', {
      //   token: self.$store.state.session.sessionToken,
      //   assignments: 0,
      //   order: 'startShift',
      //   orderAsc: 1,
      //   pageNum: 1,
      //   sectorId: 0,
      //   serviceTypeId: data.serviceId,
      //   since: since,
      //   until: until
      // }, res => {
      //   self.availability.show = true
      //   self.rsvpAvailabilityLoading = false
      //   if (res.error) {
      //     return
      //   }
      //   let drivers = []
      //   res.list.forEach(driver => {
      //     let name = driver.businessName || `${driver.firstName} ${driver.lastName}`
      //     let availableFrom = ''
      //     let availableUntil = ''
      //     if (driver.startTimestamp) {
      //       let sinceTime = moment(since, 'X').format(ft.timeFormat(self, false))
      //       // availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
      //       availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
      //       availableUntil = moment(driver.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
      //     }
      //     drivers.push({
      //       id: driver.ID,
      //       name: name,
      //       firstName: driver.firstName,
      //       lastName: driver.lastName,
      //       licenseType: driver.accountType,
      //       homeSector: driver.homeSectorName || '',
      //       availableFrom: availableFrom,
      //       availableUntil: availableUntil,
      //       mobile: driver.phoneNumber || '',
      //     })
      //   })
      //   self.$store.commit('dispatch/setAvailableDriversData', {list: drivers})
      // })
    },
    activeTabLabel (x) {
      switch (x) {
        case 0: return 'dispatch'
        case 1: return 'routedPackages'
        case 2: return 'unroutedPackages'
        case 3: return 'runs'
      }
    }
  },
  watch: {
    selectedFilter (value) { this.showFilter = value === 'custom' },
    tabIndex (value) {
      this.$store.commit('dispatch/setCurrentTable', value)
      if (value === 0) {
        this.availability.showToggle = ['UPCOMING', 'REQUIRES DISPATCH'].indexOf(this.rsvpInMap.status) > -1
      }
      if (value === 3) { // && (!this.runs.since || !this.runs.until)
        if (this.$refs.runsTableFilter.loadList()) {
          this.$refs.runsTableFilter.loadList()
        }
        // this.availability.showToggle = this.$store.state.runs.selected.length > 0
      }
      this.$store.commit('dispatch/setTabActiveData', {rsvp: this.activeTabLabel(value)})
      this.$store.commit('dispatch/removeRsvpInMap')
      this.$store.commit('dispatch/setNoSector', false)
      this.$store.commit('runs/setOtherData', {runsInMap: []})
    },
    rsvpInMap (value) {
      if (value.id === null) {
        this.rsvp = null
        return
      }
      this.rsvp = value
      if (value.status !== 'UPCOMING' && value.status !== 'REQUIRES DISPATCH') {
        return
      }

      /* Show Available drivers */
      // let now = moment()
      // let pickupTime = moment(value.pickupTime, 'MM/DD/YYYY hh:mmA')
      // let diff = pickupTime.diff(now, 'minute')
      // let limit = parseInt(this.$settings.get('findNearbyDriverLimit'))
      // if (diff > limit) {
      //   this.showDriverPanel = true
      // }
    },
    showDriverPanel (val) {
      this.$store.commit('dispatch/setDriverPanelOpen', val)
    }
  },
  mounted() {
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
$rsvp-panel-width: 890px;
$header-height: 50px;
$shrink-rsvp-panel-width: 320px;
$driver-panel-width: 560px;

.rsvp-panel-container{
  position: fixed;
  top: 0; left: 0;
  z-index: 2;
  width: $rsvp-panel-width;
  height: 100%;
  box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  border-right: 1px solid rgba(0,0,0,0.3);
}

.rsvp-panel{
  position: fixed;
  top: 101px;
  left: 0;
  overflow-y: auto;
  width: $rsvp-panel-width;
  height: calc(100% - (#{$header-height} + 51px));
  z-index: 2;
  margin-top: 2px;
}

.tabs {
  position: fixed;
  top: 50px;
  left: 0;
  width: $rsvp-panel-width;
  display: block;
  border-bottom: 1px solid rgba(0,0,0,0.3);
  border-top: 1px solid rgba(0,0,0,0.3);

  & .tab {
    display: inline-block;
    color: #0D79F2;
    position: relative;
    z-index: 2;
    font-weight: 700;
    font-size: 14px;
    padding: 15px 8px;
    text-decoration: underline;
    cursor: pointer;
    transition: all 250ms;

    &.selected {
      background-color: #fff;
      border-left: 1px solid rgba(0,0,0,0.3);
      border-right: 1px solid rgba(0,0,0,0.3);
      text-decoration: none;
      cursor: default;
    }
  }

  .total{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    line-height: 51px;
    padding: 0 20px;
    font-size: 14px;
    color: #333;
    font-weight: 600;
    span{
      color: #555;
      display: inline-block;
      margin-left: 3px;
      font-size: 13px;
      position: relative;
      top: -1px;
      font-weight: 500;
    }
  }
}

.tab-content {
  display: none;
  height: 100%;
  overflow: auto;
  &.show {
    display: block;
  }


  &.with-control { height: calc(100% - 80px); }

  & .tab-control {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    border-top: 1px solid rgba(0,0,0,0.3);
    padding: 20px 10px;
  }
}

$toggle-size: 50px;

.driver-toggle{
  position: fixed;
  right: 0;
  top: 0;
  z-index: 4;
  width: $toggle-size;
  height: $toggle-size;
  line-height: $toggle-size;
  text-align: center;
  color: #777;
  transition: all 250ms;
  border-radius: 0;

  & i { line-height: inherit; }

  &.on{
    background-color: #F25E0D;
    color: #fff;
    border-bottom-left-radius: 3px;
    box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  }
}
.available-drivers{
  position: fixed;
  top: 0;
  right: 0;
  z-index: 3;
  width: $driver-panel-width;
  height: 100%;
  background-color: #f5f5f5;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  border-bottom-left-radius: 3px;
  transition: all 250ms;

  &.hide{
    right: -#{$driver-panel-width};
    box-shadow: -2px 0 8px rgba(0,0,0,0.0);
  }
}

.map{
  position: fixed;
  top: 0;
  z-index: 2;
  left: $rsvp-panel-width;
  width: calc(100% - #{$rsvp-panel-width});
  height: 100%;

  &.shrink{
    left: $shrink-rsvp-panel-width;
    width: calc(100% - #{$shrink-rsvp-panel-width});
  }
}

.right-panel {
  z-index: 2;
  position: fixed;
  top: 0;
  left: #{$rsvp-panel-width};
  width: calc(100% - #{$rsvp-panel-width});
  height: 100%;
  & .map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55%;
  }

  & .dropzone-container {
    position: absolute;
    top: 55%;
    left: 0;
    width: 100%;
    height: 45%;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.25);
    z-index: 1;
  }
}

.header{
  position: fixed;
  top: 0; left: 0;
  width: $rsvp-panel-width;
  height: calc(#{$header-height} + 1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);
  z-index: 3;

  & .search {
    position: absolute;
    top: 0;
    left: 50px;
    width: 350px;
  }

  & .filter{
    position: absolute;
    top: 0;
    left: 400px;
  }

  .more-filter-trigger{
    position: absolute;
    top: 0;
    right: 0;
    border:1px solid rgba(0,0,0, .3);
    height: 50px;
    padding: 0 15px;
    line-height: 50px;
    border-top: none;
    border-bottom: none;
    background: #fff;
    color: #555;
    cursor: pointer;

    .fa-filter{
      margin-right: 3px;
      color: #999;
      transition: all .3s ease;
      line-height: 50px;
    }
    &:hover{
      color:#333;
      i{ color: #333; }
    }
    &.active{
      background: #eaf1f3;
      i{ color: #333; }
    }
  }

  .more-filter{ transform-origin: top center; }
}

.coverage-toggle {
  position: fixed;
  top: 60px;
  right: 0;
  background-color: #fff;
  width: $toggle-size;
  z-index: 4;
  text-align: center;
  transition: all 250ms;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 4px rgba(0,0,0,0.35);
  cursor: pointer;
  padding: 13px 0;
  // height: $toggle-size;
  // line-height: $toggle-size;

  &.hide {
    right: -($toggle-size);
    opacity: 0;
  }
}

.expand-button, .shrink-button{
  position: fixed;
  top: calc(50% - 27px);
  left: $rsvp-panel-width - 1px;
  background-color: #F4F8F9;
  padding: 15px 8px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  box-shadow: 3px 0 4px rgba(0,0,0,0.3);
  cursor: pointer;
}

.shrink-button{ top: calc(50% + 37px); }

.shrink{
  width: $shrink-rsvp-panel-width;

  .header, .rsvp-panel{ width: $shrink-rsvp-panel-width; }

  .header{
    height: calc((#{$header-height} * 2) + 1px);
    .search{
      position: relative;
      top: 0;
      left: 50px;
      width: calc(100% - 50px);
      border-bottom:1px solid #ddd;
      form{ margin-bottom: 0!important; }
    }
    .filter{
      position: relative;
      left: 0;
      top: 0;
      display: inline-block;
      float:left;
      width: 80%;
      border-right: 1px solid #fafafa;
    }
    .more-filter-trigger{
      position: relative;
      left: 0;
      width: calc(20% - 1px);
      display: inline-block;
      float:left;
      border: none;
      text-align: center;
    }
  }

  .rsvp-panel{
    top: calc(#{$header-height} * 2);
    height: calc(100% - (#{$header-height} * 2));
  }
  .expand-button, .shrink-button{ left: $shrink-rsvp-panel-width - 1px; }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.grown-in-enter-active, .grown-in-leave-active { transition: all .3s ease; }
.grown-in-enter, .grown-in-leave-to {
  transform: scale(.98);
  opacity: 0;
}

.toggle-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  $rsvp-panel-width: 100%;
  .rsvp-panel-container{
    width: $rsvp-panel-width;
  }

  .rsvp-panel{
    width: $rsvp-panel-width;
    margin: 0;
    top: 150px;
    height: calc(100% - 150px);
    &.hide-top {
      top: 101px;
    }
  }
  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 10;
    text-transform: uppercase;
    font-weight: 900;
  }

  .right-panel {
    left: 0;
    width: 100%;
    z-index: 5;
    top: 100%;
    transition: all 0.3s ease;
    background-color: #fff;
    &.showMapBox {
      top: 0;
    }
    .map {
      height: 35%;
    }
    .dropzone-container {
      top: 35%;
      height: 65%;
    }
  }

  .tabs {
    width: $rsvp-panel-width;
    top: 100px;
    display: flex;
    overflow-x: scroll;
    background-color: #fff;
    &.hide-top {
      top: 50px;
    }

    // Change this to show tabs
    .tab {
      flex-shrink: 0;
      padding: 14px 20px;
      border-right: 1px solid rgba(0, 0, 0, 0.3);
      background-color: #f4f8f9;
    }
    .total {
      display: none;
      // font-size: 13px;

      // span {
      //   font-size: 11px;
      // }
    }
  }

  .header{
    width: $rsvp-panel-width;
    .search {
      width: calc(100% - 50px);
    }

    .filter-group {
      position: absolute;
      top: 49px;
      border: 1px solid #ccc;
      display: flex;
      width: 100%;
      .filter, .more-filter-trigger {
        position: initial;
      }

      .filter {
        width: 60%;
      }
      .more-filter-trigger {
        width: calc(40% - 40px);
      }
    }
  }

  .driver-toggle {
    top: 50px;
    z-index: 14;
    &.hide {
      display: none;
    }
  }

  .available-drivers {
    z-index: 13;
    width: 100%;
  }
  .coverage-toggle {
    display: none;
  }

  .map {
    width: 100%;
    height: 100%;
    &.showInMobile {
      z-index: 2;
      left: 0;
    }
  }

  .close-map-button{
    display: block;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 3;
    width: $toggle-size;
    height: $toggle-size;
    line-height: $toggle-size;
    text-align: center;
    color: #777;
    transition: all 250ms;
    border-radius: 0;
    background-color: #eee;
    border-bottom-left-radius: 3px;
    box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  
    & i { line-height: inherit; }
  
  }
}

.availability-toggle{
  position: fixed;
  top: 120px;
  right: 0;
  z-index: 2;
  background-color: #fff;
  width: $toggle-size;
  text-align: center;
  transition: all 250ms;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 4px rgba(0,0,0,0.35);
  cursor: pointer;
  padding: 8px 0;

  & i { line-height: inherit; }

  &.open {
    box-shadow: 0 2px 4px rgba(0,0,0,0);
    // background-color: #0D79F2;
    // color: #fff;
  }

  &.hide{
    right: -70px;
  }
} 

.filter-available-drivers{
  position: fixed;
  top: 0;
  right: 0;
  z-index: 3;
  width: $driver-panel-width;
  height: 100%;
  background-color: #f5f5f5;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  border-bottom-left-radius: 3px;
  transition: all 250ms;

  &.hide{ top: -100%; }

  .message{
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    padding: 14px;
    background-color: #0D79F2;
    color: #fff;
    width: 100%;
  }
  .close-filter{
    width: 50px;
    padding: 14px 0;
    text-align: center;
    background: #579be7;
    cursor: pointer;

    i{
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dispatch/index.vue